import { render, staticRenderFns } from "./SupportMain.vue?vue&type=template&id=01cc7f5c&"
import script from "./SupportMain.vue?vue&type=script&lang=js&"
export * from "./SupportMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports